import { createReducer } from "reduxsauce";
import _ from "lodash";
import UIDs from "../../../UIDs";

import ReducerRegister from "../../ReducerRegister";
import { ActionTypes } from "../../actionTypes/screens/homework/PracticeResultActionTypes";
import PracticeResultService from "../../../services/screens/homework/PracticeResultService";
import AsyncActionReducers from "../../AsyncActionReducers";
import UnitService from "../../../services/screens/common/UnitService";

//
// Actions
//
const Actions = {
    loadScreenViewAsync: (userHomeworkUnitId, result) => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LOAD_SCREEN_VIEW_ASYNC });

            PracticeResultService.loadScreenView(
                userHomeworkUnitId,
                response => {
                    dispatch(Actions.loadScreenViewSuccess(response, result));
                },
                error => {
                    dispatch(Actions.loadScreenViewFailure(error));
                }
            );
        };
    },

    loadScreenViewSuccess: (data, result) => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_SUCCESS,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        postReducer: loadScreenViewSuccessPostReducer,
        data,
        result
    }),

    loadScreenViewFailure: error => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_FAILURE,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        error
    }),

    updateUnitResultAsync: (userHomeworkUnitId, unitResult) => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.UPDATE_UNIT_RESULT_ASYNC });

            UnitService.updateUnitResultImmediately(
                userHomeworkUnitId,
                0,
                userHomeworkUnitId,
                unitResult,
                response => {
                    dispatch(Actions.updateUnitResultSuccess(response));
                },
                error => {
                    dispatch(Actions.updateUnitResultFailure(error));
                }
            );
        };
    },

    updateUnitResultSuccess: (data) => ({
        type: ActionTypes.UPDATE_UNIT_RESULT_SUCCESS,
        parentType: ActionTypes.UPDATE_UNIT_RESULT_ASYNC,
        postReducer: updateUnitResultReducer,
        data
    }),

    updateUnitResultFailure: error => ({
        type: ActionTypes.UPDATE_UNIT_RESULT_FAILURE,
        parentType: ActionTypes.UPDATE_UNIT_RESULT_ASYNC,
        error
    }),

};

//
// Initial State
//
const INITIAL_STATE = {
    //userHomeworkUnit: null,
    data: null,
    result: null,
    generateResult: null
};

//
// Reducers
//
const buildData = (userHomeworkUnit) => {
    const { unitType = "", score, data: unitData, answer, files, childUnitIndex, childUnitChildIndex, userHomeworkUnitId, homeworkUnitId, pinyin, translation, totalScore, rank, useState, vipEnabled } = userHomeworkUnit;

    let data = { unitType, ...JSON.parse(unitData || null), userHomeworkUnitId, childUnitIndex, childUnitChildIndex, totalScore, rank, useState, vipEnabled };
    let result = { score, answer: JSON.parse(answer || null), files: JSON.parse(files || null) };

    if (data.childUnitIndex >= 0) {
        if (unitType === 'PSSO1') {
            let practiceData = data.practices[data.childUnitIndex];
            let singleData = JSON.parse(practiceData.data).singleUnits[data.childUnitChildIndex];
            data = { ...data, isComprehensiveUnit: true, unitType: practiceData.unitType, ...singleData };
            if (result.answer && result.answer.answer) {
                result.answer = JSON.parse(result.answer.answer);
            } else {
                result.answer = null;
            }
        } else {
            let singleData = data.singleUnits[data.childUnitIndex];
            data = { ...data, ...singleData };
        }
    }

    return { data, result };
};

const loadScreenViewSuccessPostReducer = (state, { data, result }) => {
    let { userHomeworkUnit } = data;
    if (userHomeworkUnit.unitType === 'PSSO1') {
        result = _.cloneDeep(result);
        if (result.answer && result.answer.answer) {
            result.answer = JSON.parse(result.answer.answer);
        } else {
            result.answer = null;
        }
    }
    return { ...state, ...buildData(userHomeworkUnit), result };
};

const updateUnitResultReducer = (state, { data }) => {
    return { ...state, ...buildData(data) }
};

// Use reduxsauce's createReducer to make it clearer for
// each action handler
const mergedReducer = createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.UPDATE_UNIT_RESULT_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.UPDATE_UNIT_RESULT_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.UPDATE_UNIT_RESULT_FAILURE]: AsyncActionReducers.failureReducer,
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(UIDs.screens.homework.practiceresult, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };
